import { NavLink } from 'react-router-dom';
import Logo from './Logo';
import AdminNotificationBell from './AdminNotificationBell';

const links = [
  { label: 'Quản lý người dùng', to: '/quan-tri/nguoi-dung', icon: 'ri-user-settings-line' },
  { label: 'Quản lý nạp/rút', to: '/quan-tri/nap-rut', icon: 'ri-bank-card-line' },
  { label: 'Lệnh giao dịch', to: '/quan-tri/lenh-giao-dich', icon: 'ri-exchange-funds-line' },
  { label: 'Giá vàng VN', to: '/quan-tri/gia-vang', icon: 'ri-copper-coin-line' },
  { label: 'Banner & tin tức', to: '/quan-tri/banner-tin-tuc', icon: 'ri-image-line' },
  { label: 'Nhật ký quản trị', to: '/quan-tri/nhat-ky', icon: 'ri-file-list-3-line' },
  { label: 'Hộp thư hỗ trợ', to: '/quan-tri/tin-nhan-ho-tro', icon: 'ri-customer-service-2-line' },
  { label: 'Chế độ bảo trì', to: '/quan-tri/bao-tri', icon: 'ri-tools-line' },
];

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-background-50">
      <header className="fixed top-0 inset-x-0 z-40 h-16 bg-background-100 border-b border-background-200/60 flex items-center justify-between px-4 md:px-6">
        <div className="flex items-center gap-3">
          <Logo />
          <span className="px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-400 text-xs font-semibold hidden sm:inline-block">Quản trị</span>
        </div>
        <div className="flex items-center gap-3">
          <AdminNotificationBell />
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-full bg-accent-500/20 flex items-center justify-center">
              <span className="text-sm font-bold text-accent-400">AD</span>
            </div>
            <span className="text-sm font-semibold text-foreground-950 hidden sm:inline">Admin</span>
          </div>
          <NavLink to="/" className="text-sm text-foreground-600 hover:text-primary-300 cursor-pointer whitespace-nowrap transition-colors">
            Thoát
          </NavLink>
        </div>
      </header>

      <div className="pt-16 flex">
        <aside className="hidden lg:block w-60 shrink-0 border-r border-background-200/60 bg-background-100 min-h-[calc(100vh-4rem)] sticky top-16 p-4">
          <nav className="space-y-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                    isActive ? 'bg-accent-500/15 text-accent-400' : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/60'
                  }`
                }
              >
                <i className={`${l.icon} text-base w-5 h-5 flex items-center justify-center`}></i>
                {l.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        <div className="flex-1 min-w-0">
          <div className="lg:hidden overflow-x-auto border-b border-background-200/60 bg-background-100 px-3 py-2 sticky top-16 z-30">
            <div className="flex gap-1">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  className={({ isActive }) =>
                    `px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap cursor-pointer ${
                      isActive ? 'bg-accent-500/15 text-accent-400' : 'text-foreground-600'
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </div>
          </div>
          <main className="p-4 md:p-6">{children}</main>
        </div>
      </div>
    </div>
  );
}